export const pxToRem = (value: number) => `${Number((value / 16).toFixed(3))}rem`
export const floatTwo = (value: number) => Number((value).toFixed(2))
